module.exports = __webpack_public_path__ + "img/173.1bf9a50.svg";